/**
 * User-related utility functions shared across applications
 */

/**
 * Determines if a user is a Workd/Developrise user based on their email domain
 * @param email The user's email address
 * @returns true if the user's email is from @workd.com or @developrise.com
 */
export function isWorkdUser(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }

  const normalizedEmail = email.toLowerCase().trim();
  return normalizedEmail.endsWith('@workd.com') || normalizedEmail.endsWith('@developrise.com');
}

/**
 * Get the list of Workd/Developrise email domains
 * @returns Array of email domains for Workd/Developrise
 */
export function getWorkdDomains(): string[] {
  return ['@workd.com', '@developrise.com'];
}

/**
 * Check if an email belongs to a specific domain
 * @param email The email address to check
 * @param domain The domain to check against (e.g., '@example.com')
 * @returns true if the email belongs to the specified domain
 */
export function isEmailFromDomain(email: string | null | undefined, domain: string): boolean {
  if (!email || !domain) {
    return false;
  }

  const normalizedEmail = email.toLowerCase().trim();
  const normalizedDomain = domain.toLowerCase().trim();

  // Add @ if not present in domain
  const domainWithAt = normalizedDomain.startsWith('@') ? normalizedDomain : `@${normalizedDomain}`;

  return normalizedEmail.endsWith(domainWithAt);
}